import { render, staticRenderFns } from "./ThematicCollection.vue?vue&type=template&id=3b7127d2&scoped=true"
import script from "./ThematicCollection.vue?vue&type=script&lang=js"
export * from "./ThematicCollection.vue?vue&type=script&lang=js"
import style0 from "./ThematicCollection.vue?vue&type=style&index=0&id=3b7127d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7127d2",
  null
  
)

export default component.exports